export default "__VITE_ASSET__DenKDwbl__"